import './press-area.scss';

const pressArea = () => {
    const dropdownBtn = document.querySelector('.dropdown-mobile');
    const dropdownCategories = document.querySelector('.press-dropdown-mobile');

    if (dropdownBtn) {
        dropdownBtn.addEventListener('click', () => {
            dropdownCategories.classList.toggle('active');
            dropdownBtn.classList.toggle('active');
        });
    }

    document.addEventListener('click', (event) => {

        if (dropdownBtn) {

            const targetElement = event.target;
            const dropdownClicked = targetElement.closest('.dropdown-mobile');
            const dropdownContent = targetElement.closest('.press-dropdown-mobile');

            if (!dropdownClicked && !dropdownContent) {
                dropdownCategories.classList.remove('active');
                dropdownBtn.classList.remove('active');
            }
        }
    });
}

export default pressArea;


